import { WpoAppointmentsRoutes } from 'pages/wpo-appointments/state/constants';

export const WLS_APPOINTMENTS_URL_PREFIX = '/wls-appointments';

export const WlsAppointmentsRoutes: Record<
  keyof typeof WpoAppointmentsRoutes,
  string
> = Object.freeze({
  INTRO: 'wlsAppointmentsIntro',
  CONTACT_DETAILS: 'wlsAppointmentsContactDetails',
  AREA_OF_CONCERN: 'wlsAppointmentsAreaOfConcern',
  LANGUAGE_SELECTION: 'wlsAppointmentsLanguageSelection',
  TIMESLOT_SELECTION: 'wlsAppointmentsTimeslotSelection',
  COUNSELLOR_SELECTION: 'wlsAppointmentsCounsellorSelection',
  APPOINTMENT_TYPE: 'wlsAppointmentsAppointmentType',
  APPOINTMENT_CONFIRMATION: 'wlsAppointmentsAppointmentConfirmation',
  BOOKING_CONFIRMATION: 'wlsAppointmentsBookingConfirmation',
  APPOINTMENT_DETAILS: 'wlsAppointmentsAppointmentDetails',
  APPOINTMENT_CANCELLED: 'wlsAppointmentsAppointmentCancelled',
  APPOINTMENT_HISTORY: 'wlsAppointmentsAppointmentHistory',
});
